/* eslint-disable max-len */
import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const { bool, node, string } = PropTypes;

const SquirclePill = ({
  children,
  className,
  isSelected,
  isUnavailable,
  ...props
}) => {
  return (
    <div
      className={classNames(
        '[&>button]:sui-bg-primary [&>button]:sui-rounded-lg [&>button]:sui-min-h-0',
        '[&>button]:sui-px-0 [&>button>div]:sui-px-3 [&>button>div]:sui-py-1',
        '[&_div]:sui-text-nowrap [&_svg]:sui-w-4 [&_svg]:sui-h-4',
        isSelected ? '[&>button]:sui-py-0 [&_p]:sui-font-bold'
          : '[&>button]:sui-py-1px',
        !isUnavailable ? '[&>button]:hover:sui-border-accent'
          : '[&>button]:sui-pointer-events-none [&>button]:sui-border-inactive [&_p]:sui-text-inactive',
        !isSelected && !isUnavailable && '[&>button:not(:disabled,_:focus)]:sui-border-strong',
        className
      )}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    >
      {children}
    </div>
  );
};

SquirclePill.propTypes = {
  children: node.isRequired,
  className: string,
  isSelected: bool,
  isUnavailable: bool
};

SquirclePill.defaultProps = {
  className: '',
  isSelected: false,
  isUnavailable: false
};

export { SquirclePill };